import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Info.css";

const Info = ({ description }) => {
    const { t: tCommon } = useTranslation('common');
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);

    useEffect(() => {
        if (showTooltip && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setTooltipPosition({
                top: rect.top - 0,
                left: rect.left + rect.width / 2
            });
        }
    }, [showTooltip]);

    return (
        <div 
            className="info-slider-container"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <div className="info-icon-wrapper" ref={iconRef}>
                <img src="/imagens/info.svg" alt={tCommon("infoIcon")} className="info-icon" />
            </div>
            {showTooltip && (
                <div 
                    className="tooltip" 
                    style={{ 
                        top: `${tooltipPosition.top}px`, 
                        left: `${tooltipPosition.left}px` 
                    }}
                >
                    {description}
                </div>
            )}
        </div>
    );
};

export default Info;
